import React from 'react';
import Harmonogram from './Harmonogram';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';

const HarmonogramPage = () => {

    const { t } = useTranslation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Harmonogram"), path: "/harmonogram"}
            ]} />
            <Harmonogram />
        </Page>
    );
};

export default HarmonogramPage;